<template>
  <div
    style="height: 100vh;overflow-y: scroll;padding-bottom: 80px;box-sizing: border-box;scrollbar-color: #e74c3c #f1f1f1;margin: 0 auto;"
  >
    <div>
      <div class="box">
        <div class="imgBox">
          <div
            style="position: absolute;bottom: 3px;left: 20%;display: flex;align-items: center;"
          >
            第1期 · 距离结束还剩
            <countdown
              :end-date="endTime"
              @finish="onCountdownFinish"
              v-if="endTime != ''"
            />
          </div>
        </div>
        <div class="lottery-container">
          <img src="../../../static/pageBg1.png" alt="" class="wheelBg" />
          <!-- 转盘容器 -->
          <div class="wheel-box">
            <!-- SVG 转盘 -->
            <svg
              ref="svgWheel"
              width="270"
              height="270"
              viewBox="0 0 300 300"
              :style="{ transform: `rotate(${rotateDeg}deg)` }"
            >
              <!-- ✅ 将 defs 提到最外层，避免重复定义 -->
              <defs>
                <path
                  v-for="(item, index) in prizes"
                  :key="index"
                  :id="`arc-${index}`"
                  :d="getTextArcPath(index)"
                  fill="none"
                />
              </defs>

              <!-- 扇形 + 文字 -->
              <g v-for="(item, index) in prizes" :key="index">
                <!-- 扇形背景 -->
                <path
                  :d="getSectorPath(index)"
                  :fill="item.color || '#f9f9f9'"
                />
                <!-- 文字：合并为一个 textPath，避免 offset 冲突 -->
                <text fill="#EF221D" font-size="20" font-weight="bold">
                  <textPath
                    :href="`#arc-${index}`"
                    startOffset="50%"
                    text-anchor="middle"
                  >
                    {{ item.prizeValue }}元
                  </textPath>
                </text>
              </g>
            </svg>

            <!-- 中心按钮 -->
            <div
              class="btn-start"
              @click="startLottery"
              v-if="!isRunning"
            ></div>
            <div class="btn-start1" v-if="isRunning"></div>
          </div>
        </div>
        <div class="bigBox">
          <img src="../../../static/btnTop.png" alt="" />
          <div class="numBox">
            <div style="display: flex;justify-content: space-between;">
              <div style="font-size: 12px;">当前抽奖机会：{{ num }}次</div>
              <div
                style="font-size: 11px;text-decoration: underline;color: #FCFF00;"
                @click="goDetail"
              >
                查看我的抽奖记录>>
              </div>
            </div>
            <div class="textBox">每邀请1位好友审核通过获得1次机会</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="history" @click="showSort" v-if="lastActivityId != ''">
          查看往期榜单>>
        </div>
        <div class="bandan">
          <div
            style="width: 100%;text-align: center;position: absolute;top: 0;left: 0;"
          >
            <img src="../../../static/bandan.png" alt="" class="banImg" />
          </div>
          <div class="numBox1">
            <div class="item" v-for="(item, index) in list" :key="index">
              <div style="width: 23px;height: 24px;margin-right: 10px;">
                <img
                  src="../../../static/one.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 0"
                />
                <img
                  src="../../../static/two.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 1"
                />
                <img
                  src="../../../static/three.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 2"
                />
              </div>
              <div>
                <div style="font-weight: 600;margin-bottom: 2px;">
                  {{ item.phone }}
                </div>
                <div>
                  已邀{{ item.inviteNum }}人 | 已认证{{
                    item.inviteVerifyNum
                  }}人 | 已赚{{ item.inviteValue }}元
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="margin: 13px 0;color: #fff;font-size: 12px;text-align: center;"
        >
          TOP3将额外获得1,000元、800元、600元现金大奖，邀请人数超400人，才有机会领取奖励；
        </div>
        <div class="info">
          <div class="infoBoder">
            <div
              style="font-size: 14px;text-align: center;display: flex;justify-content: center;align-items: center;"
            >
              <div class="solid"></div>
              <div style="margin: 0 10px;">活动规则</div>
              <div class="solid1"></div>
            </div>
            <div style="font-size: 11px;line-height: 20px;margin-top: 10px;">
              <div>
                ①邀请有奖：每成功邀请1名保安通过审核，邀请人获得1次抽奖机会（每人5元）；被邀请人得5元现金，实时到账。
              </div>
              <div>
                ②次数限制：每日最多500次抽奖，活动周期内累计不超过3500次。
              </div>
              <div>
                ③奖励到账：被邀请人5元实时到账；邀请人抽奖后红包实时到账。
              </div>
              <div>
                ④活动时间：2026年10月21日9点-2026年11月23日24点。
              </div>
              <div>
                ⑤抽奖资格有效期：仅限当期活动内有效，当期结束自动清零，不结转至下一期。
              </div>
              <div>
                ⑥排行榜：活动结束后清零，次日工作人员会联系获奖者发放TOP3奖励（1000/800/600元）。
              </div>
            </div>
            <img
              :src="imageUrl"
              alt=""
              style="width: 100%;margin: 10px 0;"
              @click="saveImg"
            />
            <div class="tip">
              对于任何作弊行为（包括但不限于批量注册、虚假认证、恶意刷奖等），平台有权冻结关联账号所有资产并追究法律责任；领取完红包的账户，15日后才可注销。
            </div>
          </div>
        </div>
        <div
          style="font-size: 10px;text-align: center;color: #fff;margin: 10px 0 20px;"
        >
          活动最终解释权归咖德平台所有，如有疑问可联系企微群管理员或客服咨询。
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <img src="../../../static/shareBtn.png" alt="" @click="OnShare" />
    </div>
    <div class="dialog" v-if="dialogVial"></div>
    <div class="dialogContent" v-if="winResult">
      <div class="winResultBox" style="margin: 15vh auto 0;">
        <div class="winResult">
          <div
            style="display: flex;align-items: center;color: #FF3E3E;position: absolute;top: 34%;left: 45%;"
          >
            <div style="font-size: 66px;font-weight: 500;">{{ winResult }}</div>
            <div style="margin-top: 40px;font-weight: 400;">元</div>
          </div>
          <div
            style="color: #FFB2A6;width: 230px;font-size: 12px;position: absolute;bottom: 80px;left: 70px;"
          >
            您本次抽中 {{ winResult }} 元现金红包！奖励将于 24
            小时后发放至您的咖德钱包，请注意查收。
          </div>
        </div>
        <img
          src="../../../static/closeImg.png"
          alt=""
          style="width: 26px;height: 26px;margin-top: 25px;"
          @click="closeWinResult"
        />
      </div>
    </div>
    <div class="dialogContent" v-if="sortVial">
      <div class="winResultBox">
        <div class="bandan">
          <div
            style="width: 100%;text-align: center;position: absolute;top: 0;left: 0;"
          >
            <img src="../../../static/bandan.png" alt="" class="banImg" />
          </div>
          <div class="numBox1" style="overflow: hidden;">
            <div
              class="item"
              v-for="(item, index) in list1"
              :key="index"
              style="text-align: left;"
            >
              <div style="width: 23px;height: 24px;margin-right: 10px;">
                <img
                  src="../../../static/one.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 0"
                />
                <img
                  src="../../../static/two.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 1"
                />
                <img
                  src="../../../static/three.png"
                  alt=""
                  class="itemImg"
                  v-if="index == 2"
                />
              </div>
              <div>
                <div style="font-weight: 600;margin-bottom: 2px;">
                  {{ item.phone }}
                </div>
                <div>
                  已邀{{ item.inviteNum }}人 | 已认证{{
                    item.inviteVerifyNum
                  }}人 | 已赚{{ item.inviteValue }}元
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="../../../static/closeImg.png"
          alt=""
          style="width: 26px;height: 26px;margin-top: 25px;"
          @click="closeSort"
        />
      </div>
    </div>
    <div class="dialogContent" v-if="overVial">
      <div class="overBox">
        <div
          style="width: 100%;text-align: right;padding-right: 10px;box-sizing: border-box;"
        >
          <div @click="closeOverResult">×</div>
        </div>
        <div style="margin-top: 40px;font-weight: 600;font-size: 18px;">
          活动已结束
        </div>
        <div
          style="margin-top: 20px;font-size: 14px;padding: 0 20px;box-sizing: border-box;"
        >
          本次活动已结束，感谢参与！敬请期待下一期！已获得的奖励将正常发放。
        </div>
        <div class="knowBtn" @click="closeOverResult">知道了</div>
      </div>
    </div>
    <div class="dialogContent" v-if="shareVial">
      <div class="overBox">
        <div
          style="width: 100%;text-align: right;padding-right: 10px;box-sizing: border-box;"
        >
          <div @click="closeShare">×</div>
        </div>
        <div style="margin-top: 40px;font-weight: 600;font-size: 18px;">
          暂无抽奖机会
        </div>
        <div
          style="margin-top: 20px;font-size: 14px;padding: 0 20px;box-sizing: border-box;"
        >
          您今日 /
          本周抽奖次数已用尽，邀请更多保安通过审核即可获得新的抽奖机会哦！
        </div>
        <div class="knowBtn" @click="OnShare">去邀请</div>
      </div>
    </div>
  </div>
</template>

<script>
import countdown from "@/components/countdown.vue";
// 工具函数：角度转坐标（-90°偏移使0°在顶部）
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

// 生成扇形路径
function describeArc(x, y, radius, startAngle, endAngle) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  return [
    "M",
    x,
    y,
    "L",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
    "Z"
  ].join(" ");
}

export default {
  components: {
    countdown
  },
  name: "SvgLotteryWheel",
  data() {
    return {
      isRunning: false,
      rotateDeg: 0,
      segmentAngle: 0,
      winResult: null,
      prizes: [],
      list: [],
      list1: [],
      dialogVial: false,
      sortVial: false,
      overVial: false,
      shareVial: false,
      num: 0,
      endTime: "",
      activeID: "",
      lastActivityId: "",
      imageUrl: "https://down.baoanlailou.com/file/activity/activeBgCode.png"
    };
  },
  mounted() {
    if (this.$route.query.token) {
      localStorage.setItem("TOKEN", this.$route.query.token);
      this.getInfo();
    } else {
      this.clickAskari();
      window.setUserInfo = val => {
        try {
          let obj = JSON.parse(val);
          let token = obj.loginUserVO.accessToken;
          localStorage.setItem("TOKEN", token);
          this.getInfo();
        } catch (error) {
          console.error("请求失败:", error);
        }
      };
    }
  },
  methods: {
    showSort() {
      this.sortVial = true;
      this.dialogVial = true;
    },
    OnShare() {
      if (this.detectMobileOS() == "IOS") {
        this.callIOS();
      } else {
        this.callAndroid();
      }
    },
    saveImg() {
      if (this.detectMobileOS() == "IOS") {
        try {
          let obj = window.webkit.messageHandlers["imageClick"].postMessage(
            this.imageUrl
          );
        } catch (error) {
          console.error("请求失败:", error);
        }
      } else {
        Android.imageClick(this.imageUrl);
      }
    },
    goDetail() {
      if (this.detectMobileOS() == "IOS") {
        this.callIOS1();
      } else {
        this.callAndroid1();
      }
    },
    callAndroid1() {
      Android.transactionDetails();
    },
    callIOS1() {
      window.webkit.messageHandlers["transactionDetails"].postMessage("H5回调");
    },
    callAndroid() {
      Android.securityInviteFriendsQRCode();
    },
    // 调用 iOS 原生退伍军人方法
    callIOS() {
      window.webkit.messageHandlers["securityInviteFriendsQRCode"].postMessage(
        "H5回调"
      );
    },
    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone必须放在前面，因为它的UA也包含"Android"
      if (/windows phone/i.test(userAgent)) return "Windows Phone";

      if (/android/i.test(userAgent)) return "Android";

      // iOS检测
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        // 检测是否是桌面模式下的Safari
        const isSafari = navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        return isSafari ? "IOS" : "IOS";
      }
      return "Unknown";
    },
    clickAskari() {
      if (this.detectMobileOS() == "IOS") {
        try {
          window.webkit.messageHandlers["getUserInfo"].postMessage(
            "H5获取用户信息"
          );
        } catch (error) {
          console.error("请求失败:", error);
        }
      } else {
        Android.getUserInfo("来自 JavaScript 的消息");
      }
    },
    getList() {
      this.$axios
        .post(`/mapi/api/activity/fact/ranking`, { activityId: this.activeID })
        .then(({ data }) => {
          this.list = data.factRanking;
        })
        .catch()
        .finally();
    },
    getList1() {
      this.$axios
        .post(`/mapi/api/activity/fact/ranking`, {
          activityId: this.lastActivityId
        })
        .then(({ data }) => {
          this.list1 = data.factRanking;
        })
        .catch()
        .finally();
    },
    getNum() {
      this.$axios
        .post(`/mapi/api/activity/lottery/chances`, {
          activityId: this.activeID
        })
        .then(({ data }) => {
          this.num = data.num;
        })
        .catch()
        .finally();
    },
    getInfo() {
      this.$axios
        .post(`/mapi/api/activity/base/info`)
        .then(({ data }) => {
          let time = data.activity.endDate;
          this.endTime = time;
          let arr = data.prize;
          if (arr[0]) {
            arr[0].color = "#FFECC7";
          }
          if (arr[1]) {
            arr[1].color = "#FAE3AE";
          }
          if (arr[2]) {
            arr[2].color = "#F7DA7C";
          }
          if (arr[3]) {
            arr[3].color = "#FACE4B";
          }
          if (arr[4]) {
            arr[4].color = "#FAC326";
          }
          if (arr[5]) {
            arr[5].color = "#FFB200";
          }
          if (arr[6]) {
            arr[6].color = "#FFA514";
          }
          this.prizes = arr;
          this.segmentAngle = 360 / arr.length;
          this.activeID = data.activity.id;
          this.lastActivityId =
            data.lastActivity && data.lastActivity.id
              ? data.lastActivity.id
              : "";
          if (this.lastActivityId != "") {
            this.getList1();
          }
          this.getNum();
          this.getList();
        })
        .catch()
        .finally();
    },
    onCountdownFinish() {
      this.overVial = true;
      this.dialogVial = true;
    },
    closeWinResult() {
      this.dialogVial = false;
      this.winResult = null;
    },
    closeOverResult() {
      this.overVial = false;
      this.dialogVial = false;
    },
    closeShare() {
      this.shareVial = false;
      this.dialogVial = false;
    },
    closeSort() {
      this.sortVial = false;
      this.dialogVial = false;
    },
    // 扇形路径
    // getSectorPath(index) {
    //   const startAngle = index * this.segmentAngle;
    //   const endAngle = (index + 1) * this.segmentAngle;
    //   return describeArc(150, 150, 140, startAngle, endAngle);
    // },
    getSectorPath(index) {
      const total = this.prizes.length;
      const anglePer = (2 * Math.PI) / total; // 每份弧度
      const startAngle = index * anglePer - Math.PI / 2; // 从顶部开始（-90°）
      const endAngle = (index + 1) * anglePer - Math.PI / 2;

      const R = 140; // 外圆半径（建议 ≤ 140，留出中心按钮空间）
      const r = 40; // 内圆半径（可选，做环形）

      const x1 = 150 + R * Math.cos(startAngle);
      const y1 = 150 + R * Math.sin(startAngle);
      const x2 = 150 + R * Math.cos(endAngle);
      const y2 = 150 + R * Math.sin(endAngle);

      // 构建扇形路径（带内圆）
      return [
        `M 150,150`, // 移动到圆心
        `L ${x1},${y1}`, // 到外圆起点
        `A ${R},${R} 0 0,1 ${x2},${y2}`, // 外圆弧
        `L 150,150`, // 回到圆心
        "Z"
      ].join(" ");
    },
    // 文字弧线路径（短弧，用于 textPath）
    // getTextArcPath(index) {
    //   const centerAngle = (index + 0.5) * this.segmentAngle;
    //   const arcWidth = 20; // 弧线跨度（角度）
    //   const startAngle = centerAngle - arcWidth / 2;
    //   const endAngle = centerAngle + arcWidth / 2;
    //   const radius = 110; // 文字离中心距离

    //   const start = polarToCartesian(150, 150, radius, startAngle);
    //   const end = polarToCartesian(150, 150, radius, endAngle);
    //   const largeArcFlag = arcWidth <= 180 ? "0" : "1";

    //   return [
    //     "M",
    //     start.x,
    //     start.y,
    //     "A",
    //     radius,
    //     radius,
    //     0,
    //     largeArcFlag,
    //     0,
    //     end.x,
    //     end.y
    //   ].join(" ");
    // },
    getTextArcPath(index) {
      const total = this.prizes.length;
      const anglePer = (2 * Math.PI) / total;
      const startAngle = index * anglePer - Math.PI / 2;
      const endAngle = (index + 1) * anglePer - Math.PI / 2;

      const textRadius = 110; // 文字弧线半径（比扇形小，避免靠边）

      const x1 = 150 + textRadius * Math.cos(startAngle);
      const y1 = 150 + textRadius * Math.sin(startAngle);
      const x2 = 150 + textRadius * Math.cos(endAngle);
      const y2 = 150 + textRadius * Math.sin(endAngle);

      // 注意：文字路径应为“逆时针”还是“顺时针”？
      // 如果文字倒置，把 large-arc-flag 改为 1 或调整角度方向
      const largeArcFlag = anglePer > Math.PI ? 1 : 0;

      return `M ${x1},${y1} A ${textRadius},${textRadius} 0 ${largeArcFlag},1 ${x2},${y2}`;
    },
    // 按权重随机选奖
    selectPrizeByWeight() {
      return this.$axios
        .post(`/mapi/api/activity/lottery`, { activityId: this.activeID })
        .then(({ data }) => {
          for (var i = 0; i < this.prizes.length; i++) {
            if (this.prizes[i].id == data.prize.id) {
              return i;
            }
          }
        })
        .catch()
        .finally();
    },
    // 开始抽奖
    async startLottery() {
      if (this.num <= 0) {
        this.shareVial = true;
        this.dialogVial = true;
        return;
      }
      if (this.isRunning) return;
      this.isRunning = true;
      this.winResult = null;

      try {
        const prizeIndex = await this.selectPrizeByWeight();
        const halfAngle = this.segmentAngle / 2;
        const targetCenter = prizeIndex * this.segmentAngle + halfAngle;
        const extraRounds = 5;
        const currentDeg = this.rotateDeg % 360;
        const neededDeg = (360 - targetCenter - currentDeg + 360) % 360;
        const targetDeg = this.rotateDeg + extraRounds * 360 + neededDeg;
        await this.rotateTo(targetDeg);
        this.winResult = this.prizes[prizeIndex].prizeValue;
        this.dialogVial = true;
        this.getNum();
      } catch (error) {
        console.error("抽奖失败:", error);
      } finally {
        this.isRunning = false;
      }
    },
    // 旋转动画
    rotateTo(targetDeg) {
      return new Promise(resolve => {
        const svg = this.$refs.svgWheel;
        svg.style.transition = "transform 4s cubic-bezier(0.2, 0.8, 0.2, 1)";
        this.rotateDeg = targetDeg;
        setTimeout(() => {
          svg.style.transition = "";
          resolve();
        }, 4000);
      });
    }
  }
};
</script>

<style scoped>
.history {
  width: 100%;
  text-align: center;
  padding: 5px 0;
  box-sizing: border-box;
  font-size: 12px;
  color: #ffe3e3;
  margin: 10px 0 20px;
  background: rgba(255, 255, 255, 0.23);
  border-radius: 4px;
}
.knowBtn {
  width: 266px;
  height: 50px;
  background: #1677ff;
  box-shadow: 0px 2 10px 0px rgba(75, 116, 255, 0.27);
  border-radius: 10px;
  margin: 30px auto 0;
  font-size: 18px;
  color: #fff;
  line-height: 50px;
}
.winResult {
  width: 100%;
  height: 100%;
  background-image: url("../../../static/modelBg2.png");
  background-size: 100% 100%;
  padding-top: 120px;
  box-sizing: border-box;
}
.overBox {
  width: 315px;
  height: 279px;
  margin: 200px auto;
  background-image: url("../../../static/modelBg1.png");
  background-size: 100% 100%;
  padding-top: 30px;
  box-sizing: border-box;
}
.dialogContent {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  text-align: center;
}
.winResultBox {
  width: 353px;
  height: 391px;
  margin: 28vh auto 0;
  position: relative;
}
.dialog {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #333333;
  box-shadow: 0px 1 2px 0px rgba(0, 0, 0, 0.5);
  opacity: 0.58;
  z-index: 99;
}
.bottomBox {
  width: 100%;
  height: 80px;
  background: linear-gradient(180deg, #fb872f 0%, #f54f15 100%);
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottomBox img {
  width: 295px;
  margin: 20px auto;
  display: block;
}
.tip {
  width: 285px;
  height: 68px;
  background: linear-gradient(180deg, #ff8a31 0%, #ff5216 100%);
  border-radius: 8px;
  border: 2px solid #ffe176;
  margin: 0 auto;
  color: #feff17;
  font-size: 10px;
  line-height: 18px;
  padding: 4px 4px;
  box-sizing: border-box;
}
.solid {
  width: 20px;
  height: 2px;
  background: linear-gradient(270deg, #ffffff 0%, #ff663d 100%);
  border-radius: 1px;
}
.solid1 {
  width: 20px;
  height: 2px;
  background: linear-gradient(243deg, #ff663e 0%, #ffffff 100%);
  border-radius: 1px;
}
.infoBoder {
  width: 100%;
  padding: 12px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px dashed #fff;
  color: #fff;
}
.info {
  width: 100%;
  padding: 12px 10px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #ff603c 0%, #ff884b 100%);
  border-radius: 8px;
}
.item {
  display: flex;
  margin-bottom: 10px;
  font-size: 12px;
}
.itemImg {
  width: 23px;
  height: 24px;
  margin-right: 10px;
}
.bandan {
  width: 100%;
  position: relative;
  padding-top: 20px;
  box-sizing: border-box;
}
.banImg {
  width: 198px;
}
.numBox1 {
  width: 100%;
  /* height: 150px; */
  background: linear-gradient(180deg, #fff4ef 0%, #ffffff 100%);
  color: #a0270c;
  overflow: scroll;
  padding: 20px 15px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  scrollbar-color: #a0270c #f1f1f1;
}
.textBox {
  width: 273px;
  height: 24px;
  background: #ee3c3c;
  border-radius: 4px;
  text-align: center;
  margin: 10px auto 0;
  font-size: 10px;
  color: #ffe3e3;
  line-height: 24px;
}
.bigBox {
  width: 340px;
  position: relative;
  margin: 20px auto;
  padding-top: 20px;
  box-sizing: border-box;
}
.bigBox img {
  width: 229px;
  position: absolute;
  top: 0;
  left: 16%;
}
.numBox {
  width: 340px;
  height: 72px;
  background: linear-gradient(180deg, #ff0d0d 0%, #ff884b 100%);
  border-radius: 8px;
  margin: 0 auto;
  padding: 13px 10px;
  box-sizing: border-box;
  color: #fff;
}
.content {
  width: 100%;
  background: #f54f15;
  padding: 8px 16px;
  box-sizing: border-box;
}
.box {
  width: 100%;
  height: 750px;
  background-image: url("../../../static/pageBg.png");
  background-size: 100% 100%;
  padding-top: 40px;
  box-sizing: border-box;
}
.imgBox {
  width: 302px;
  height: 201px;
  margin: 0 auto;
  background-image: url("../../../static/topImg.png");
  background-size: 100% 100%;
  text-align: center;
  font-size: 12px;
  position: relative;
  color: #fff9db;
}
.lottery-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: Arial, sans-serif;
  position: relative;
}

.wheel-box {
  position: relative;
  width: 270px;
  height: 270px;
  margin: 46px 0 0;
}

.wheelBg {
  position: absolute;
  top: 11%;
  width: 330px;
}

.pointer {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 20px solid #e74c3c;
  top: 95px; /* 稍微上移一点，避免和外圈重叠 */
  z-index: 30;
}

.btn-start {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 96px;
  border: none;
  cursor: pointer;
  outline: none;
  z-index: 20;
  background-image: url("../../../static/chou.png");
  background-size: 100% 100%;
  user-select: none; /* 防止文字被选中 */
  -webkit-tap-highlight-color: transparent; /* 移动端点击高亮 */
}
.btn-start1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 96px;
  border: none;
  cursor: pointer;
  outline: none;
  z-index: 20;
  background-image: url("../../../static/chou1.png");
  background-size: 100% 100%;
  user-select: none; /* 防止文字被选中 */
  -webkit-tap-highlight-color: transparent; /* 移动端点击高亮 */
}

.btn-start:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.result {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #e74c3c;
}
</style>



// WEBPACK FOOTER //
// src/view/lottery/lottery.vue